module.exports = __webpack_public_path__ + "img/eduardo-avalos.276876d5.png";